module.exports = __webpack_public_path__ + "img/Subscribe to our ret.8f81adb5.svg";